import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import useDocumentTitle from '../../utils/useDocumentTitle';
import Card from '../../components/Card';
import Button from '../../components/Button';
import NoticeBoardFilters from './components/NoticeBoardFilters';
import NoticeBoardTable from './components/NoticeBoardTable';
import EditNoticeDialog from './components/EditNoticeDialog';
import {
  closeEditNoticeDialog,
  getIsEditNoticeDialogVisible,
  openEditNoticeDialog,
} from './store';
import CurrentUser from '../../models/CurrentUser';
import {
  ADMIN_CREATE_NOTICE,
  ADMIN_UPDATE_NOTICE,
  ADMIN_DELETE_NOTICE,
} from '../../common/permissions';

const SettingsNoticeBoard = () => {
  const { t } = useTranslation();
  useDocumentTitle([t('settings'), t('noticeBoard')]);
  const canUpdate = !!useSelector(
    CurrentUser.select.getPermissionGrant(ADMIN_UPDATE_NOTICE),
  );
  const canCreate = !!useSelector(
    CurrentUser.select.getPermissionGrant(ADMIN_CREATE_NOTICE),
  );
  const canDelete = !!useSelector(
    CurrentUser.select.getPermissionGrant(ADMIN_DELETE_NOTICE),
  );

  const isOpen = useSelector(getIsEditNoticeDialogVisible);

  const dispatch = useDispatch();
  const handleOnCancel = useCallback(() => {
    dispatch(closeEditNoticeDialog());
  }, [dispatch]);

  const handleCreateNotice = useCallback(() => {
    dispatch(openEditNoticeDialog());
  }, [dispatch]);

  return (
    <>
      <Card>
        <div className="stack-4" data-testid="variables-table">
          <NoticeBoardFilters canCreate={canCreate} />
          <NoticeBoardTable canDelete={canDelete} canUpdate={canUpdate} />
        </div>
      </Card>
      <EditNoticeDialog
        open={isOpen}
        onCancel={handleOnCancel}
        canDelete={canDelete}
        canUpdate={canUpdate}
        canCreate={canCreate}
      />
    </>
  );
};

export default SettingsNoticeBoard;
